import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-estes-quote',
  templateUrl: './estes-quote.component.html',
  styleUrls: ['./estes-quote.component.sass']
})
export class EstesQuoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
